import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import i18n from '../../i18n';
import { ReactComponent as FluPhoneDesktopIcon } from '../../static/images/svg/fluent_phone-desktop-16-filled.svg';
import { ReactComponent as FluPhoneIcon } from '../../static/images/svg/fluent_phone-28-filled.svg';

/** 与 Figma 1838:52035 卡头一致：正文-加粗 20/24、主题紫；渠道图标 24px */
const titleSx = {
    color: 'var(--text-primary-300)',
    fontWeight: 700,
    whiteSpace: 'nowrap',
} as const;

export type FirstScreenMediaCardHeaderProps = {
    /** 模块标题（如餐厅活动公告） */
    title: string;
    /** 已使用槽位或已选数量 */
    usedCount: number;
    /** 槽位/上限总数 */
    totalCount: number;
    /**
     * 是否在 QOP 文案前展示手机图标（与「通用/COP」桌面图标并列）；稿面与餐厅活动公告一致，默认开启。
     */
    showQopPhoneIcon?: boolean;
};

/**
 * 首屏多图类卡片标题行：左起标题、已用/总数、通用/COP（桌面图标）、QOP（手机图标）；各块 `space-between` 分散。
 * @param props - 标题、用量与 QOP 是否带手机图标
 */
export function FirstScreenMediaCardHeader(props: FirstScreenMediaCardHeaderProps): JSX.Element {
    const { title, usedCount, totalCount, showQopPhoneIcon = true } = props;
    /** 通用/COP 与 QOP 文案 */
    const universalCopLabel = i18n.t('first_screen_setting_page_channel_universal_cop');
    /** QOP 渠道短标签 */
    const qopLabel = i18n.t('first_screen_setting_page_channel_qop');

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                minWidth: 0,
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                rowGap: 1,
                columnGap: { xs: 2, sm: 0 },
            }}
        >
            <Typography variant="subtitle1" sx={titleSx}>
                {title}
            </Typography>
            <Typography variant="subtitle1" sx={titleSx}>
                {i18n.t('first_screen_setting_page_activity_image_slot_usage', {
                    used: usedCount,
                    max: totalCount,
                })}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'var(--icon-primary-300)' }}>
                <FluPhoneDesktopIcon style={{ width: 24, height: 24, flexShrink: 0 }} aria-hidden />
                <Typography variant="subtitle1" sx={titleSx}>
                    {universalCopLabel}
                </Typography>
            </Box>
            {showQopPhoneIcon ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'var(--icon-primary-300)' }}>
                    <FluPhoneIcon style={{ width: 24, height: 24, flexShrink: 0 }} aria-hidden />
                    <Typography variant="subtitle1" sx={titleSx}>
                        {qopLabel}
                    </Typography>
                </Box>
            ) : (
                <Typography variant="subtitle1" sx={titleSx}>
                    {qopLabel}
                </Typography>
            )}
        </Box>
    );
}
